/** HASC logo blues for parent-packet input chrome (all sites). */
export const HASC_BLUE = {
  primary: '#0060C0',
  primaryHover: '#0050B0',
  sky: '#0090E0',
  highlight: '#E6F0FB',
  progressTrack: '#D6E6F7',
};

export const PACKET_MAX_WIDTH = 1040;
export const PACKET_FORM_CARD_MAX_WIDTH = 720;

/** @deprecated Use PACKET_MAX_WIDTH */
export const WOODMERE_PACKET_MAX_WIDTH = PACKET_MAX_WIDTH;
/** @deprecated Use PACKET_FORM_CARD_MAX_WIDTH */
export const WOODMERE_FORM_CARD_MAX_WIDTH = PACKET_FORM_CARD_MAX_WIDTH;

const SITE_LABEL_BY_SLUG = {
  woodmere: 'Woodmere',
  rockland: 'Rockland',
  '14th-ave': '14th Ave',
  '55th-street': '55th Street',
};

/** Display name for packet chrome header (prefer API site_name). */
export function formatPacketSiteLabel(siteName, siteSlug) {
  const fromApi = String(siteName || '').trim();
  if (fromApi) return fromApi;
  const slug = String(siteSlug || '').trim();
  return SITE_LABEL_BY_SLUG[slug] || 'HASC';
}

/**
 * Sticky-header session label for packet chrome.
 * Summer / calendar-year (sessionType SUMMER, or start year === end year) → "Summer 2026"
 * School year → "SY 2026-27"
 * Never "2026-2026" and never mask a Summer session as a school year.
 */
export function formatPacketSchoolYearLabel(schoolYear, sessionType) {
  const raw = String(schoolYear || '').trim();
  const type = String(sessionType || '').trim().toUpperCase();
  const m = raw.match(/^(\d{4})\s*[-–—]\s*(\d{2,4})$/);
  let start = null;
  let end = null;
  if (m) {
    start = parseInt(m[1], 10);
    end = parseInt(m[2], 10);
    if (end < 100) end = Math.floor(start / 100) * 100 + end;
  }

  const isSummer =
    type === 'SUMMER'
    || (start != null && end != null && start === end);

  if (isSummer) {
    const year = start != null ? start : (raw.match(/\d{4}/) ? parseInt(raw.match(/\d{4}/)[0], 10) : null);
    return year != null ? `Summer ${year}` : 'Summer';
  }

  if (start != null && end != null) {
    const endYy = String(end % 100).padStart(2, '0');
    return `SY ${start}-${endYy}`;
  }

  if (raw) return raw;
  return 'SY 2026-27';
}

/** @deprecated Use formatPacketSchoolYearLabel */
export const formatWoodmereSchoolYearLabel = formatPacketSchoolYearLabel;
